export default {
  setCreditCardPayments(state, creditCardPayments) {
    state.creditCardPayments = creditCardPayments;
  },
  setEnabledPaymentMethods(state, enabledPaymentMethods) {
    state.enabledPaymentMethods = enabledPaymentMethods;
  },
};
